import moment from 'moment';

import { formatCompactMoney, formatToFixedMoneyWithLocale } from 'Helpers/formatService';

/**
 * IB-703 — Contract Management Dashboard helpers.
 *
 * Two money renderers, matching the Overview/Approvals convention:
 *  - `money` (compact, e.g. "£35.8M") for headline KPI figures,
 *  - `detailMoney` (full, thousands-separated) for in-panel detail cells.
 */
export const money = (symbol, val) => `${symbol ?? ''}${formatCompactMoney(val ?? 0)}`;

export const detailMoney = (symbol, val) => `${symbol ?? ''}${formatToFixedMoneyWithLocale(val ?? 0)}`;

/**
 * Format an ISO (YYYY-MM-DD) contract end date for display as "31 Mar 2026", matching the
 * mockup and the project's other date panels. The raw value stays in the payload for logic.
 */
export const formatEndDate = (isoDate) => (isoDate ? moment(isoDate, 'YYYY-MM-DD').format('DD MMM YYYY') : '');

/**
 * Round a percentage to a whole number, guarding non-finite input.
 */
export const wholePercent = (value) => {
    const numeric = Number(value);
    return isFinite(numeric) ? Math.round(numeric) : 0;
};

/**
 * Sub-tab ids on the Contract Management face, targeted by the "Review" action on the
 * unsigned callouts (see ProcurementContractManagementTab, which listens for the switch event).
 */
export const CONTRACT_MANAGEMENT_TAB_IDS = {
    expenditure: 'contract-management---expenditure-contracts',
    revenue: 'contract-management---revenue-contracts',
};

/**
 * Custom DOM event used to switch the Contract Management sub-tab from a nested component
 * (the unsigned "Review" actions) without threading callbacks through every layer.
 */
export const SWITCH_CONTRACT_MANAGEMENT_TAB_EVENT = 'SWITCH_CONTRACT_MANAGEMENT_TAB';

/**
 * Custom DOM event that asks the dashboard to refetch (mirrors the Overview tab's
 * REFETCH_PROCUREMENT_DASHBOARD contract).
 */
export const REFETCH_PROCUREMENT_DASHBOARD_EVENT = 'REFETCH_PROCUREMENT_DASHBOARD';

/**
 * Utilisation-bar fill colour for the contracted-vs-actuals by-type bars, drawn from
 * tailwind.config.js. Per the IB-703 mockup every type's bar uses the same green fill.
 */
export const BY_TYPE_BAR_COLOUR = 'tw-bg-green';
